module.exports = new __parcel__URL__("ishi_face.24d5a103.png").toString();